export default __webpack_public_path__ + "./assets/background-mobile__4a9d8d7331704fe68029014b5c535d5c.jpg";